import FamilyAccessContainer from './FamilyAccessContainer';

export default FamilyAccessContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/FamilyAccess/index.js